import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiService } from '../../core/api';
import { ResponseDatas } from '../../core/api/types';

import { CreateVehicleRequest, Vehicle } from './types';

@Injectable({
  providedIn: 'root'
})
export class VehiclesService {
  private readonly apiService = inject(ApiService);

  addVehicle(vehicle: CreateVehicleRequest): Observable<Vehicle> {
    return this.apiService.post<Vehicle>('Vehicles', vehicle);
  }

  deleteVehicle(id: number): Observable<void> {
    return this.apiService.delete(`Vehicles/${id}`);
  }

  getVehicle(id: number): Observable<Vehicle> {
    return this.apiService.get<Vehicle>(`Vehicles/${id}`);
  }

  getVehiclesForCustomer(customerId: number): Observable<Vehicle[]> {
    return this.apiService
      .get<ResponseDatas<Vehicle[]>>(`Vehicles/customer/${customerId}`)
      .pipe(map((response) => response.datas));
  }

  updateVehicle(vehicle: Vehicle): Observable<Vehicle> {
    return this.apiService.put<Vehicle>('Vehicles', vehicle);
  }
}
